import React, { useRef } from 'react';
import ReactInputMask, { Props as InputProps } from 'react-input-mask';

import { useField } from 'formik';

import { Container, Optional, Label, Box, TextOnlyContainer } from './styles';

type Props = Omit<InputProps, 'mask'> & {
  name: string;
  label?: string;
  optional?: boolean;
  mask?: string;
  isRequired?: boolean;
  isTextOnly?: boolean;
};

const Input: React.FC<Props> = ({
  name,
  label = null,
  optional = false,
  mask = '',
  isRequired,
  isTextOnly,
  defaultValue,
  ...rest
}) => {
  const inputRef = useRef(null);
  const [field, meta, helpers] = useField(name);
  const { value } = field;
  const { error } = meta;
  const { setValue } = helpers;

  return (
    <Container>
      {(label || optional) && (
        <Box isTextOnly={isTextOnly}>
          {label && (
            <Label
              isRequired={isRequired}
              htmlFor={name}
              isTextOnly={isTextOnly}
            >
              {label}
            </Label>
          )}{' '}
          {optional && <Optional>(opcional)</Optional>}
        </Box>
      )}
      <TextOnlyContainer isTextOnly={isTextOnly}>
        <ReactInputMask
          id={name}
          ref={inputRef}
          defaultValue={defaultValue}
          {...rest}
          mask={mask}
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            if (rest.onChange) {
              rest.onChange(e);
            }
          }}
        />
      </TextOnlyContainer>
      {error && <span>{error}</span>}
    </Container>
  );
};

export default Input;
